module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-title', [_c('h5', [_vm._v("Shipped Orders by Monthly")])]), _vm._v(" "), _c('v-card-text', [_c('line-chart', {
    attrs: {
      "data": _vm.ordersData
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('h5', [_vm._v("User Count by Monthly")])]), _vm._v(" "), _c('v-card-text', [_c('line-chart', {
    attrs: {
      "data": _vm.usersData
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c4dc536","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reports/index.vue
// module id = 641
// module chunks = 1